import styled from 'styled-components'

import { CircularLoader } from '@blade/ui-kit'
import { ProfileIcon } from '@root/shared/ui-kit'

import { AuthModalHeading } from '../auth-modal-heading'

type Props = {
  title: React.ReactNode
  description?: React.ReactNode
  variant: 'loading' | 'error'
}

export const AuthInfoMessage: React.FC<Props> = ({
  title,
  description,
  variant,
}) => {
  return (
    <Root>
      <AuthModalHeading icon={ProfileIcon} />
      <Body>
        {variant === 'loading' ? <CircularLoader size={24} /> : undefined}
        <Title>{title}</Title>
        {description ? <Description>{description}</Description> : undefined}
      </Body>
    </Root>
  )
}

const Root = styled.div`
  min-width: 285px;
  display: grid;
  grid-template-rows: auto 1fr 30px;
  height: 100%;
`

const Body = styled.div`
  display: grid;
  grid-auto-flow: row;
  justify-content: center;
  justify-items: center;
  align-self: center;
`

const Title = styled.div`
  color: var(--text-12);
  margin-top: 10px;

  text-align: center;
  font-size: 14px;
  font-weight: 600;
`

const Description = styled.div`
  color: var(--textA-9);
  text-align: center;

  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
`
